import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/components/_prefooter.scss';
import { FaInstagram } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import ContactUsForm from './ContactUsForm';


const PreFooter = () => {
  return (
    <div className="prefooter-container">
      {/* Left section: Company / About Info */}
      <div className="prefooter-info">
        <h3 className="company-title">
          <Link to="/company">
            Hero Dynamics
          </Link>
        </h3>

        <p className="centered-text">
          Empowering scientists and researchers 
          to make informed decisions by developing innovative technologies
          that reduce environmental impact and enhance data acquisition in 
          extreme environments.
        </p>

     
      </div>



      <div className="prefooter-social">
        <h3>Our social media</h3>
        <ul className="social-list">
          <li>
            <a href="https://www.linkedin.com/company/herodynamics/about/" target="_blank" rel="noopener noreferrer">
              <FaLinkedin size={50} style={{ marginRight: '10px' }} />
            </a>
          </li>
          <li>
            <a href="https://www.instagram.com/hero_dynamics?igsh=ZW0yMWdmMzFsNGs2" target="_blank" rel="noopener noreferrer">
              <FaInstagram size={50} style={{ marginRight: '10px' }} />
            </a>
          </li>
        </ul>
      </div>
               
      <div className="prefooter-contact">
        <h3>Contact us</h3>
        <ContactUsForm></ContactUsForm>
      

      </div>
    </div>
  );
};

export default PreFooter;
